// stores/layout.js
import { defineStore } from "pinia";
import { ref } from "vue";

export const useLayoutStore = defineStore("layout", () => {
  const drawer = ref(true);
  const mini = ref(false);
  const isRTL = ref(true);

  function toggleDrawer() {
    if (drawer.value) {
      mini.value = !mini.value;
    } else {
      drawer.value = !drawer.value;
      mini.value = false;
    }
  }

  function toggleMini() {
    mini.value = !mini.value;
    drawer.value = true;
  }

  function closeDrawer() {
    drawer.value = false;
  }
  function toggleRTL() {
    isRTL.value = !isRTL.value; // قلب حالة RTL
    localStorage.setItem("lang", isRTL.value ? "ar" : "en");
  }

  return {
    drawer,
    mini,
    isRTL,
    toggleDrawer,
    toggleMini,
    closeDrawer,
    toggleRTL,
  };
});
